/**
 * @generated SignedSource<<d89100b352f3a1214371cba6b5213187>>
 * @relayHash a4a7d92a918ee5f8e30325e161ec20b3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cc852b83cd91027240167016d4cb1978110507d7da66d45f045c74dd113feaba

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AssociateProjectToFieldSchemeModalQuery$variables = {
  cloudId: string;
  projectAri: string;
};
export type AssociateProjectToFieldSchemeModalQuery$data = {
  readonly jira_doesTenantHaveNonNfaProjects: boolean | null;
  readonly jira_isTenantConvertedToNfa: boolean | null;
  readonly project: {
    readonly associatedFieldConfigScheme?: {
      readonly name: string | null;
      readonly schemeId: string | null;
    } | null;
    readonly associatedFieldScheme?: {
      readonly name: string | null;
      readonly schemeId: string | null;
    } | null;
    readonly name?: string;
    readonly projectId?: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"AssociateProjectToFieldSchemeModal" | "AssociateProjectToFieldSchemeModal_legacySchemes">;
  } | null;
};
export type AssociateProjectToFieldSchemeModalQuery = {
  response: AssociateProjectToFieldSchemeModalQuery$data;
  variables: AssociateProjectToFieldSchemeModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v3 = {
  "args": (v2/*: any*/),
  "kind": "ScalarField",
  "name": "jira_isTenantConvertedToNfa"
},
v4 = {
  "args": (v2/*: any*/),
  "kind": "ScalarField",
  "name": "jira_doesTenantHaveNonNfaProjects"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectAri"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = {
  "kind": "ScalarField",
  "name": "schemeId"
},
v9 = [
  (v8/*: any*/),
  (v7/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
},
v12 = [
  (v8/*: any*/),
  (v7/*: any*/),
  (v11/*: any*/)
],
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 40
  }
],
v14 = [
  (v8/*: any*/),
  (v7/*: any*/),
  (v11/*: any*/),
  (v10/*: any*/)
],
v15 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v16 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v17 = [
  "input"
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AssociateProjectToFieldSchemeModalQuery",
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/),
      {
        "alias": "project",
        "args": (v5/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "concreteType": "JiraFieldConfigScheme",
                "kind": "LinkedField",
                "name": "associatedFieldConfigScheme",
                "plural": false,
                "selections": (v9/*: any*/)
              },
              {
                "concreteType": "JiraFieldScheme",
                "kind": "LinkedField",
                "name": "associatedFieldScheme",
                "plural": false,
                "selections": (v9/*: any*/)
              },
              {
                "kind": "FragmentSpread",
                "name": "AssociateProjectToFieldSchemeModal"
              },
              {
                "kind": "FragmentSpread",
                "name": "AssociateProjectToFieldSchemeModal_legacySchemes"
              }
            ],
            "type": "JiraProject"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AssociateProjectToFieldSchemeModalQuery",
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/),
      {
        "alias": "project",
        "args": (v5/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "concreteType": "JiraFieldConfigScheme",
                "kind": "LinkedField",
                "name": "associatedFieldConfigScheme",
                "plural": false,
                "selections": (v12/*: any*/)
              },
              {
                "concreteType": "JiraFieldScheme",
                "kind": "LinkedField",
                "name": "associatedFieldScheme",
                "plural": false,
                "selections": (v12/*: any*/)
              },
              {
                "args": (v13/*: any*/),
                "concreteType": "JiraFieldSchemesConnection",
                "kind": "LinkedField",
                "name": "availableFieldSchemes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFieldSchemesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFieldScheme",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v14/*: any*/)
                      },
                      (v15/*: any*/)
                    ]
                  },
                  (v16/*: any*/)
                ],
                "storageKey": "availableFieldSchemes(first:40)"
              },
              {
                "args": (v13/*: any*/),
                "filters": (v17/*: any*/),
                "handle": "connection",
                "key": "AssociateProjectToFieldSchemeModal_adminPagesFieldSchemes__availableFieldSchemes",
                "kind": "LinkedHandle",
                "name": "availableFieldSchemes"
              },
              {
                "args": (v13/*: any*/),
                "concreteType": "JiraFieldConfigSchemesConnection",
                "kind": "LinkedField",
                "name": "availableFieldConfigSchemes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFieldConfigSchemesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFieldConfigScheme",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v14/*: any*/)
                      },
                      (v15/*: any*/)
                    ]
                  },
                  (v16/*: any*/)
                ],
                "storageKey": "availableFieldConfigSchemes(first:40)"
              },
              {
                "args": (v13/*: any*/),
                "filters": (v17/*: any*/),
                "handle": "connection",
                "key": "AssociateProjectToFieldSchemeModal_adminPagesFieldSchemes__availableFieldConfigSchemes",
                "kind": "LinkedHandle",
                "name": "availableFieldConfigSchemes"
              }
            ],
            "type": "JiraProject"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "cc852b83cd91027240167016d4cb1978110507d7da66d45f045c74dd113feaba",
    "metadata": {},
    "name": "AssociateProjectToFieldSchemeModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f8d48c304b52c9b1aaf9eb54b6ab00f9";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
